<template>
  <div>
    <b-overlay
      :show="isLoading"
      spinner-variant="primary"
      spinner-larger
    >
      <b-row>
        <b-col
          cols="12"
          md="12"
        >
          <b-card title="">
            <b class="pr-1">Air Quality</b>
            <b class="sidebar-right">{{ datenow }}</b>
          </b-card>
          <b-row
            xl="12"
            sm="12"
          >
            <b-col
              v-for="key in Object.keys(dataDevices).filter(key => key !== 'wind_direction')"
              :key="`device_${key}`"
              cols="6"
              md="3"
            >
              <DeviceCard
                :device="getDevice(key)"
              />
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="8">
              <b-row>
                <b-col cols="6">
                  <b-card title="PM2.5">
                    <vue-apex-charts
                      class="vue-apex-charts"
                      type="line"
                      height="290"
                      :options="lineChartPM2_5.chartOptions"
                      :series="lineChartPM2_5.series"
                    />
                  </b-card>
                </b-col>
                <b-col cols="6">
                  <b-card title="PM10">
                    <vue-apex-charts
                      class="vue-apex-charts"
                      type="line"
                      height="290"
                      :options="lineChartPM10.chartOptions"
                      :series="lineChartPM10.series"
                    />
                  </b-card>
                </b-col>
                <b-col cols="6">
                  <b-card title="Temperature">
                    <vue-apex-charts
                      class="vue-apex-charts"
                      type="line"
                      height="290"
                      :options="lineChartAirTemperature.chartOptions"
                      :series="lineChartAirTemperature.series"
                    />
                  </b-card>
                </b-col>
                <b-col cols="6">
                  <b-card title="Humidity">
                    <vue-apex-charts
                      class="vue-apex-charts"
                      type="line"
                      height="290"
                      :options="lineChartHumidity.chartOptions"
                      :series="lineChartHumidity.series"
                    />
                  </b-card>
                </b-col>
              </b-row>
            </b-col>
            <b-col cols="4">
              <b-row>
                <b-col cols="12">
                  <b-card title="Wind Information">
                    <b-row>
                      <b-col cols="6">
                        Wind Speed
                      </b-col>
                      <b-col cols="6">
                        {{ getDevice('wind_speed').value }} {{ getDevice('wind_speed').unit }}
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col cols="6">
                        Direction (Degrees)
                      </b-col>
                      <b-col cols="6">
                        {{ getDevice('wind_direction').value }} {{ getDevice('wind_direction').unit }}
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col cols="6">
                        Direction
                      </b-col>
                      <b-col cols="6">
                        North
                      </b-col>
                    </b-row>
                  </b-card>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-overlay>
  </div>
</template>

<script>
import {
  BCard, BOverlay, BRow, BCol,
} from 'bootstrap-vue'
import moment from 'moment'
import axios from 'axios'
import VueApexCharts from 'vue-apexcharts'
import { $themeColors } from '@themeConfig'
import DeviceCard from './components/DeviceAirQualityCard.vue'

const getCurrentTime = () => moment(String(new Date())).format("dddd, DD MMM' YYYY LTS")

export default {
  components: {
    VueApexCharts,
    BCard,
    BOverlay,
    BRow,
    BCol,
    DeviceCard,
  },
  data() {
    return {
      datas: [],
      lastData: null,
      datenow: moment(String(new Date())).format("dddd, DD MMM' YYYY LTS"),
      show: false,
      isLoading: false,
      isInitialLoad: true,
      currentTimeInterval: null,
      dashboardInterval: null,
      dataDevices: {
        noise: {
          name: 'Noise Level',
          device_name: 'noise',
          unit: 'dB',
          color_class: 'purple-color',
        },
        pm2_5: {
          name: 'PM2.5',
          device_name: 'pm2_5',
          unit: 'ppm',
          color_class: 'orange-color',
        },
        pm10: {
          name: 'PM10',
          device_name: 'pm10',
          unit: 'ppm',
          color_class: 'yellow-color',
        },
        air_temperature: {
          name: 'Temperature',
          device_name: 'air_temperature',
          unit: '°C',
          color_class: 'orange-color',
        },
        air_humidity: {
          name: 'Air Humidity',
          device_name: 'air_humidity',
          unit: '%',
          color_class: 'blue-color',
        },
        pressure: {
          name: 'Pressure',
          device_name: 'pressure',
          unit: 'hPa',
          color_class: 'tosca-color',
        },
        wind_speed: {
          name: 'Wind Speed',
          device_name: 'wind_speed',
          unit: 'm/s',
          color_class: 'blue-light-color',
        },
        wind_direction: {
          name: 'Wind Direction',
          device_name: 'wind_direction',
          unit: '°',
          color_class: 'purple-color',
        },
      },
      lineChartPM2_5: {
        series: [
          {
            name: 'Temperature',
            data: [],
          },
        ],
        chartOptions: {
          chart: {
            zoom: {
              enabled: false,
            },
            toolbar: {
              show: false,
            },
          },
          markers: {
            strokeWidth: 7,
            strokeOpacity: 1,
            strokeColors: [$themeColors.light],
            colors: [$themeColors.warning],
          },
          colors: ['#28C76F', '#247BA0', '#EA5455'],
          dataLabels: {
            enabled: false,
            value: {
              formatter(val) {
                return val
              },
            },
          },
          stroke: {
            curve: 'straight',
          },
          grid: {
            xaxis: {
              lines: {
                show: true,
              },
            },
          },
          tooltip: {
            custom(data) {
              return `${'<div class="px-1 py-50"><span>'}${data.series[data.seriesIndex][data.dataPointIndex]
              }</span></div>`
            },
          },
          xaxis: {
            categories: [],
            labels: {
              style: {
                colors: '',
              },
            },
          },
          yaxis: {
            labels: {
              style: {
                colors: '',
              },
            },
            min: 0,
            max: 150,
          },
        },
      },
      lineChartPM10: {
        series: [
          {
            name: 'Temperature',
            data: [],
          },
        ],
        chartOptions: {
          chart: {
            zoom: {
              enabled: false,
            },
            toolbar: {
              show: false,
            },
          },
          markers: {
            strokeWidth: 7,
            strokeOpacity: 1,
            strokeColors: [$themeColors.light],
            colors: [$themeColors.warning],
          },
          colors: ['#28C76F', '#247BA0', '#EA5455'],
          dataLabels: {
            enabled: false,
            value: {
              formatter(val) {
                return val
              },
            },
          },
          stroke: {
            curve: 'straight',
          },
          grid: {
            xaxis: {
              lines: {
                show: true,
              },
            },
          },
          tooltip: {
            custom(data) {
              return `${'<div class="px-1 py-50"><span>'}${data.series[data.seriesIndex][data.dataPointIndex]
              }</span></div>`
            },
          },
          xaxis: {
            categories: [],
            labels: {
              style: {
                colors: '',
              },
            },
          },
          yaxis: {
            labels: {
              style: {
                colors: '',
              },
            },
            min: 0,
            max: 150,
          },
        },
      },
      lineChartAirTemperature: {
        series: [
          {
            name: 'Temperature',
            data: [],
          },
        ],
        chartOptions: {
          chart: {
            zoom: {
              enabled: false,
            },
            toolbar: {
              show: false,
            },
          },
          markers: {
            strokeWidth: 7,
            strokeOpacity: 1,
            strokeColors: [$themeColors.light],
            colors: [$themeColors.warning],
          },
          colors: ['#28C76F', '#247BA0', '#EA5455'],
          dataLabels: {
            enabled: false,
            value: {
              formatter(val) {
                return val
              },
            },
          },
          stroke: {
            curve: 'straight',
          },
          grid: {
            xaxis: {
              lines: {
                show: true,
              },
            },
          },
          tooltip: {
            custom(data) {
              return `${'<div class="px-1 py-50"><span>'}${data.series[data.seriesIndex][data.dataPointIndex]
              }</span></div>`
            },
          },
          xaxis: {
            categories: [],
            labels: {
              style: {
                colors: '',
              },
            },
          },
          yaxis: {
            labels: {
              style: {
                colors: '',
              },
            },
            min: 0,
            max: 150,
          },
        },
      },
      lineChartHumidity: {
        series: [
          {
            name: 'Temperature',
            data: [],
          },
        ],
        chartOptions: {
          chart: {
            zoom: {
              enabled: false,
            },
            toolbar: {
              show: false,
            },
          },
          markers: {
            strokeWidth: 7,
            strokeOpacity: 1,
            strokeColors: [$themeColors.light],
            colors: [$themeColors.warning],
          },
          colors: ['#28C76F', '#247BA0', '#EA5455'],
          dataLabels: {
            enabled: false,
            value: {
              formatter(val) {
                return val
              },
            },
          },
          stroke: {
            curve: 'straight',
          },
          grid: {
            xaxis: {
              lines: {
                show: true,
              },
            },
          },
          tooltip: {
            custom(data) {
              return `${'<div class="px-1 py-50"><span>'}${data.series[data.seriesIndex][data.dataPointIndex]
              }</span></div>`
            },
          },
          xaxis: {
            categories: [],
            labels: {
              style: {
                colors: '',
              },
            },
          },
          yaxis: {
            labels: {
              style: {
                colors: '',
              },
            },
            min: 0,
            max: 150,
          },
        },
      },
      history_pm2_5: [],
      history_pm10: [],
      history_air_temperature: [],
      history_humidity: [],
      realtime_time: [],
    }
  },
  beforeDestroy() {
    if (this.currentTimeInterval) clearInterval(this.currentTimeInterval)
    if (this.dashboardInterval) clearInterval(this.dashboardInterval)
  },
  created() {
    this.currentTimeInterval = setInterval(() => this.updateCurrentTime(), 1000)
    this.dashboardInterval = setInterval(() => this.getData(), 30000)
    this.lineChartPM2_5.chartOptions.xaxis.labels.style.colors = '#ffffff'
    this.lineChartPM2_5.chartOptions.yaxis.labels.style.colors = '#ffffff'

    this.lineChartPM10.chartOptions.xaxis.labels.style.colors = '#ffffff'
    this.lineChartPM10.chartOptions.yaxis.labels.style.colors = '#ffffff'

    this.lineChartAirTemperature.chartOptions.xaxis.labels.style.colors = '#ffffff'
    this.lineChartAirTemperature.chartOptions.yaxis.labels.style.colors = '#ffffff'

    this.lineChartHumidity.chartOptions.xaxis.labels.style.colors = '#ffffff'
    this.lineChartHumidity.chartOptions.yaxis.labels.style.colors = '#ffffff'
    this.getData()
  },
  methods: {
    injectData(resp) {
      this.history_pm2_5 = []
      this.history_pm10 = []
      this.history_air_temperature = []
      this.history_humidity = []

      this.lineChartPM2_5.series[0] = {
        name: 'COD Avg : ',
        data: this.history_pm2_5,
      }

      this.lineChartPM10.series[0] = {
        name: 'COD Avg : ',
        data: this.history_pm10,
      }

      this.lineChartAirTemperature.series[0] = {
        name: 'COD Avg : ',
        data: this.history_air_temperature,
      }

      this.lineChartHumidity.series[0] = {
        name: 'COD Avg : ',
        data: this.history_humidity,
      }

      this.lineChartPM2_5.chartOptions = {
        xaxis: { categories: this.realtime_time },
      }

      this.lineChartPM10.chartOptions = {
        xaxis: { categories: this.realtime_time },
      }

      this.lineChartAirTemperature.chartOptions = {
        xaxis: { categories: this.realtime_time },
      }

      this.lineChartHumidity.chartOptions = {
        xaxis: { categories: this.realtime_time },
      }

      this.lineChartPM2_5.chartOptions.annotations = {
        yaxis: [{
          y: 700,
          borderColor: '#F89599',
          label: {
            borderColor: '#F89599',
            style: {
              color: '#fff',
              background: '#F89599',
            },
            text: 'MAX VALUE',
          },
        },
        {
          y: 0,
          borderColor: '#F89599',
          label: {
            borderColor: '#F89599',
            style: {
              color: '#fff',
              background: '#F89599',
            },
            text: 'MIN VALUE',
          },
        }],
      }

      this.lineChartPM10.chartOptions.annotations = {
        yaxis: [{
          y: 800,
          borderColor: '#F89599',
          label: {
            borderColor: '#F89599',
            style: {
              color: '#fff',
              background: '#F89599',
            },
            text: 'MAX VALUE',
          },
        },
        {
          y: 0,
          borderColor: '#F89599',
          label: {
            borderColor: '#F89599',
            style: {
              color: '#fff',
              background: '#F89599',
            },
            text: 'MIN VALUE',
          },
        }],
      }

      this.lineChartAirTemperature.chartOptions.annotations = {
        yaxis: [{
          y: 50,
          borderColor: '#F89599',
          label: {
            borderColor: '#F89599',
            style: {
              color: '#fff',
              background: '#F89599',
            },
            text: 'MAX VALUE',
          },
        },
        {
          y: 0,
          borderColor: '#F89599',
          label: {
            borderColor: '#F89599',
            style: {
              color: '#fff',
              background: '#F89599',
            },
            text: 'MIN VALUE',
          },
        }],
      }

      this.lineChartHumidity.chartOptions.annotations = {
        yaxis: [{
          y: 80,
          borderColor: '#F89599',
          label: {
            borderColor: '#F89599',
            style: {
              color: '#fff',
              background: '#F89599',
            },
            text: 'MAX VALUE',
          },
        },
        {
          y: 0,
          borderColor: '#F89599',
          label: {
            borderColor: '#F89599',
            style: {
              color: '#fff',
              background: '#F89599',
            },
            text: 'MIN VALUE',
          },
        }],
      }

      const startIndex = 0
      const endIndex = Math.min(10, resp.length)
      resp.slice(startIndex, endIndex).map(x => {
        const updatedData = { ...x }
        this.history_pm2_5.push(updatedData.pm2_5)
        this.history_pm10.push(updatedData.pm10)
        this.history_air_temperature.push(updatedData.air_temperature)
        this.history_humidity.push(updatedData.air_humidity)

        updatedData.recorded_at = this.$options.filters.formatDateTime(updatedData.recorded_at)
        this.realtime_time.push(updatedData.recorded_at)
        return updatedData
      })
    },
    getDevice(deviceName) {
      const device = this.dataDevices[deviceName]
      return {
        ...device,
        value: this.lastData[deviceName],
      }
    },
    updateCurrentTime() {
      this.datenow = getCurrentTime()
    },
    getData() {
      this.isLoading = this.isInitialLoad // Hanya set isLoading menjadi true pada initial load

      const api = process.env.VUE_APP_DEVICE_API
      const headers = {
        authorization: `Bearer ${localStorage.getItem('accessToken')}`,
      }

      axios.get(`${api}/internal/dashboard/air-quality`, { headers })
        .then(response => {
          console.log('Air Quality Data:', response.data)
          if (response.data && response.data.data && response.data.data.length > 0) {
            this.datas = response.data.data
            const [lastData] = response.data.data
            this.lastData = lastData
            this.injectData(this.datas)
          } else {
            console.error('Invalid response format or empty data array.')
          }

          this.isLoading = false // Set isLoading menjadi false setelah data diterima
          this.isInitialLoad = false // Tandai initial load telah selesai
        })
        .catch(error => {
          console.error('Error fetching data:', error)
          this.isLoading = false // Set isLoading menjadi false jika terjadi error
          this.isInitialLoad = false // Tandai initial load telah selesai
        })
    },
  },
}
</script>

<style lang="scss">
.my-custom-class .card-title {
  color: white;
}
.dot {
  height: 10px;
  width: 10px;
  border-radius: 50%;
  display: inline-block;
  &.normal {
    background-color: #03ff2d;
  }

  &.abnormal {
    background-color: #FC4C02;
  }

  &.offline {
    background-color: #0E74FF;
  }
}

.device-flag {
  height: 5px;
  border-radius: 5px;
  &.orange-color {
    background-color: #fcb177;
  }
  &.blue-color {
    background-color: #8fc0fa;
  }
  &.blue-light-color {
    background-color: #63e0f2;
  }
  &.purple-color {
    background-color: #d2a8fe;
  }
  &.tosca-color {
    background-color: #6ddfd5;
  }
  &.yellow-color {
    background-color: #f8db5b;
  }
}
</style>
